// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__k2xoy","navbar--link":"Navbar_navbar--link__Zn3cD","navbar__link":"Navbar_navbar__link__vlrsh"};